import { useCallback, useEffect } from "react";

import purify from "dompurify";
import { useTranslation } from "pro-features/components/WithTranslation";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME,
    DUNNINGS_SITEWIDE_BANNER_CTA_LOCATION,
    REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME,
} from "app/components/Dunnings/dunningsConstants";
import {
    StyledReactivateTrialDunningsSitewideBanner,
    ReactivateTrialBannerText,
} from "app/components/Dunnings/ReactivateTrialDunningsSitewideBanner/ReactivateTrialDunningsSitewideBannerStyled";
import { useDunnings } from "app/components/hooks/useDunnings";
import { usePageTopBannerStripReveal } from "app/components/PageTopBanner/bannerRevealContext";
import { allTrackers } from "app/services/track/track";

export const ReactivateTrialDunningsSitewideBanner = () => {
    const translate = useTranslation();
    const { onDunningsButtonClicked } = useDunnings();
    const stripProps = usePageTopBannerStripReveal();

    useEffect(() => {
        allTrackers.dispatchTrackEvent(
            "banner",
            "show",
            `${REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME}/${DUNNINGS_SITEWIDE_BANNER_CTA_LOCATION}`,
        );
    }, []);

    const onButtonClick = useCallback(
        () =>
            onDunningsButtonClicked(
                `${REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME}/${DUNNINGS_SITEWIDE_BANNER_CTA_LOCATION}/${DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME}`,
                "package",
            ),
        [onDunningsButtonClicked],
    );

    return (
        <StyledReactivateTrialDunningsSitewideBanner
            {...stripProps}
            data-automation="reactivate-trial-dunnings-sitewide-banner"
        >
            <Flex gap="8px">
                <SWReactIcons
                    iconName="gift"
                    iconColor={colorsPalettes.carbon[0]}
                    size="sm"
                />

                <ReactivateTrialBannerText
                    fontVariant="subtitle2"
                    color={colorsPalettes.carbon[0]}
                    type="Roboto"
                    dangerouslySetInnerHTML={{
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        __html: purify.sanitize(translate("dunnings.reactivateAccount.banner.text")),
                    }}
                />
            </Flex>

            <Button
                onClick={onButtonClick}
                type="inverted"
            >
                {translate("dunnings.reactivateAccount.banner.button")}
            </Button>
        </StyledReactivateTrialDunningsSitewideBanner>
    );
};
